import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import { normalize } from '@/utils';

import Code from './Code';

function LayersDemo({ variant, reveal, enableShadows }) {
  return (
    <Wrapper>
      <Contents
        style={{
          '--rotate': normalize(reveal, 0, 100, 0, -45) + 'deg',
        }}
      >
        <ShadowWrapper>
          {enableShadows && <HeaderShadow />}
          {enableShadows && <DialogShadow />}
        </ShadowWrapper>
        <Header
          style={{
            '--z': enableShadows
              ? normalize(reveal, 0, 100, 0, 60) + 'px'
              : 0,
          }}
        >
          <Logo src="/images/designing-shadows/fake-logo.svg" />
          <ButtonGroup>
            <ButtonWrapper>
              <Button>Log in</Button>
            </ButtonWrapper>
            <ButtonWrapper>
              <Button>Sign up</Button>
            </ButtonWrapper>
          </ButtonGroup>
        </Header>
        <Dialog
          style={{
            '--z': enableShadows
              ? normalize(reveal, 0, 100, 0, 120) + 'px'
              : 0,
          }}
        >
          <h2>Are you sure?</h2>
          <p>This action cannot be undone.</p>
          <DialogActions>
            <ButtonGroup>
              <ButtonWrapper>
                <Button>Cancel</Button>
              </ButtonWrapper>
              <ButtonWrapper>
                <Button>Confirm</Button>
              </ButtonWrapper>
            </ButtonGroup>
          </DialogActions>
        </Dialog>
      </Contents>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --perspective: 1200px;
  position: relative;
  perspective: var(--perspective);
  width: 100%;
`;

const Contents = styled.div`
  transform: rotateY(var(--rotate));
  background: hsl(285deg 90% 90%);
  height: 450px;
  perspective: var(--perspective);
  will-change: transform;
`;

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 75px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  transform: translate3d(calc(var(--z) * -1), 0, var(--z));
  perspective: var(--perspective);
  will-change: transform;
`;

const Logo = styled.img`
  height: 32px;
`;

const ShadowWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Stop shadows from leaking out */
  overflow: hidden;
`;

const HeaderShadow = styled(Header)`
  transform: none;
  background: hsl(285deg 40% 40% / 0.5);
  transform: translate(1.5px, 3px);
  filter: blur(3px);
`;

const ButtonWrapper = styled.div`
  position: relative;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const Button = styled.button`
  display: block;
  position: relative;
  padding: 6px 16px;
  background: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  /* transform: translate3d(calc(var(--z) * -1), 0, var(--z)); */
`;

const ButtonShadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: hsl(0deg 0% 0% / 0.4);
  filter: blur(1.5px);
  transform: translate(0.5px, 2px);
  border-radius: 4px;
`;

const Dialog = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 70%;
  height: 50%;
  margin: auto;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 24px;
  text-align: left;
  transform: translate3d(calc(var(--z) * -1), 0, var(--z));

  h2 {
    font-size: 1.25rem;
    margin-bottom: 8px;
  }
`;

const DialogShadow = styled(Dialog)`
  background: hsl(285deg 40% 40% / 0.35);
  filter: blur(12px);
  transform: translate(4px, 8px);
  border-radius: 0px;
`;

const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
  margin: 0px -24px -24px;
  margin-top: auto;
  border-top: 1px solid hsl(0deg 0% 0% / 0.05);
  border-radius: 0px 0px 8px 8px;
`;

export default LayersDemo;
